import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BusinessClientRetriveQrCodeBlockData from '../../../Models/Content/BusinessClientRetriveQrCodeBlockData';
import BusinessClientRetriveQrCode from './BusinessClientRetriveQrCode';

export default class BusinessClientRetriveQrCodeBlock extends EpiComponent<BusinessClientRetriveQrCodeBlockData> {

    public render(): ReactNode | ReactNodeArray | null {
        return (
            <>
                <div className={'benefit-block'}>
                    <BusinessClientRetriveQrCode iContent={this.props.data} context={this.getContext()} />
                </div>
            </>
        );
    }
}
